<template>
  <v-layout class="one-edge-shadow">
    <v-flex
      :class="!access_token ? 'px-lg-12 px-md-12 py-lg-3 py-md-3' : 'pl-4'"
    >
      <!-- Header for desktop -->
      <v-layout py-3 v-if="$vuetify.breakpoint.mdAndUp" class="header-height">
        <v-flex
          shrink
          flex-start
          mr-3
          @click="$router.push('/')"
          style="cursor:pointer;"
        >
          <img width="150px" :src="require('../assets/tcdc-color.png')" />
        </v-flex>
        <v-flex flex-center pr-6>
          <loading
            color="#FD5246"
            :active.sync="isLoadingSearch"
            :can-cancel="false"
            :is-full-page="true"
          ></loading>
          <v-text-field
            v-model="keyword"
            hide-details
            outlined
            dense
            placeholder="Search"
            prepend-inner-icon="search"
            style="background: #FFF; border-radius: 8px"
            color="#FD5246"
            @keyup.enter="search"
          ></v-text-field>
        </v-flex>
        <v-flex shrink flex-center my-n3 mx-md-4 mx-sm-2>
          <div
            class="font-weight-bold"
            style="cursor: pointer"
            :class="{
              'toolbar-active':
                activeMainMenu === 1 || currentRouteName === 'HomePage',
            }"
            height="100%"
            @click="onActive(1)"
          >
            {{ $t("homepage") }}
          </div>
        </v-flex>
        <v-flex shrink flex-center my-n3 mx-md-4 mx-sm-2>
          <div
            class="font-weight-bold"
            style="cursor: pointer"
            :class="{
              'toolbar-active':
                activeMainMenu === 2 ||
                currentRouteName === 'Creator' ||
                currentRouteName === 'SubCurated',
            }"
            height="100%"
            @click="onActive(2)"
          >
            {{ $t("creator-portfolio") }}
          </div>
        </v-flex>
        <v-flex shrink flex-center my-n3 mx-md-4 mx-sm-2>
          <div
            style="cursor: pointer"
            :class="{
              'toolbar-active':
                activeMainMenu === 3 || currentRouteName === 'TopRank',
            }"
            class="font-weight-bold"
            height="100%"
            @click="onActive(3)"
          >
            {{ $t("toprank") }}
          </div>
        </v-flex>
        <LangSwitcher class="mr-3"></LangSwitcher>
        <v-flex
          shrink
          flex-center
          :class="{ 'mr-5': access_token, 'my-n3': !access_token }"
        >
          <v-layout v-if="access_token">
            <v-flex style="cursor: pointer;" @click="onClickMenuList(1)">
              <v-img
                width="40px"
                height="40px"
                style="border-radius: 100%"
                :src="
                  profile
                    ? checkImage(profile.mem_info, 'avatar')
                    : require('../assets/user_profile.png')
                "
              ></v-img>
            </v-flex>
            <v-flex class="shrink align-center d-flex ml-2">
              <v-menu offset-y transition="slide-y-transition" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on" class="profile-list"
                    >arrow_drop_down_circle
                  </v-icon>
                </template>
                <v-list>
                  <v-list-item
                    v-for="(item, i) in lists"
                    :key="i"
                    @click="onClickMenuList(item.id)"
                  >
                    <v-icon class="mr-2">{{ item.icon }}</v-icon>
                    <v-list-item-title style="font-size: 14px;">
                      {{
                        switchLanguage === "th"
                          ? item.name_list_th
                          : item.name_list_en
                      }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-flex>
          </v-layout>
          <v-layout v-else>
            <v-flex ml-2>
              <v-btn color="#FD5246" outlined @click="goLogin">
                <span :class="{ 'toolbar-active': activeMainMenu === 4 }">
                  {{ $t("login") }}
                </span>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex shrink flex-center my-n3 v-if="access_token">
          <v-btn
            @click="routePusher()"
            color="#FD5246"
            dark
            depressed
            block
            height="100%"
            tile
          >
            <v-icon class="mr-2">add</v-icon>
            {{ $t("create") }}
          </v-btn>
        </v-flex>
      </v-layout>

      <!-- Header for mobile -->
      <v-layout justify-space-between py-3 v-else class="header-height">
        <v-flex class="shrink d-flex justify-start align-center">
          <v-layout>
            <v-flex shrink>
              <v-btn depressed fab @click="drawer = !drawer" color="transparent"
                ><v-app-bar-nav-icon
                  style="color: #EF3E2E;"
                ></v-app-bar-nav-icon>
              </v-btn>
            </v-flex>
          </v-layout>

          <v-layout>
            <v-flex>
              <v-navigation-drawer
                width="100%"
                height="100%"
                fixed
                v-model="drawer"
                style="background: #fff; top: 76px; margin-bottom: -76px;"
              >
                <v-layout pa-5 column>
                  <v-flex>
                    <v-layout>
                      <v-flex>
                        <v-layout v-if="!access_token">
                          <v-flex>
                            <v-btn text>
                              <span style="font-size: 16px" @click="goLogin">
                                {{ $t("login") }}
                              </span>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                        <v-divider
                          v-if="!access_token"
                          class="my-5"
                        ></v-divider>
                        <v-layout v-if="access_token">
                          <v-flex>
                            <v-btn text @click="onClickMenuList(1)">
                              <span style="font-size: 16px">{{
                                $t("profile")
                              }}</span>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                        <v-divider v-if="access_token" class="my-5"></v-divider>

                        <v-layout>
                          <v-flex>
                            <v-btn
                              class="mb-2"
                              text
                              height="100%"
                              @click="onActive(1)"
                            >
                              <span style="font-size: 16px">{{
                                $t("homepage")
                              }}</span>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                        <v-divider class="my-5"></v-divider>

                        <v-layout>
                          <v-flex>
                            <v-btn
                              class="mb-2 text-start"
                              text
                              height="100%"
                              @click="onActive(2)"
                            >
                              <span style="font-size: 16px">{{
                                $t("creator-portfolio")
                              }}</span>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                        <v-divider class="my-5"></v-divider>

                        <v-layout>
                          <v-flex>
                            <v-btn
                              class="mb-2 text-start"
                              text
                              height="100%"
                              @click="onActive(3)"
                            >
                              <span style="font-size: 16px">{{
                                $t("toprank")
                              }}</span>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                        <v-divider class="my-5"></v-divider>

                        <v-layout v-if="access_token">
                          <v-flex>
                            <v-btn text
                              ><span
                                style="font-size: 16px"
                                @click="onClickMenuList(2)"
                              >
                                {{ $t("logout") }}
                              </span></v-btn
                            >
                          </v-flex>
                        </v-layout>
                        <v-divider v-if="access_token" class="my-5"></v-divider>

                        <v-layout class="justify-start pl-4">
                          <v-flex shrink>
                            <LangSwitcher></LangSwitcher>
                          </v-flex>
                        </v-layout>
                        <!-- <v-divider class="my-5"></v-divider> -->
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-navigation-drawer>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex
          :class="access_token ? 'justify-center' : 'justify-end'"
          class="d-flex align-center pr-3"
          @click="$router.push('/')"
        >
          <img width="150px" :src="require('../assets/tcdc-color.png')" />
        </v-flex>

        <v-flex xs3 sm2 my-n3 v-if="access_token">
          <v-btn
            @click="routePusher()"
            color="#FD5246"
            dark
            depressed
            block
            height="100%"
            tile
          >
            <v-icon small>add</v-icon>
            <span>{{ $t("create") }}</span>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-flex>
    <loading
      color="#FD5246"
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="false"
    ></loading>
  </v-layout>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import LangSwitcher from "./LangSwitcher";
import { domain, imgPath } from "../services/Constants";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "Header",
  components: {
    LangSwitcher,
    Loading,
  },
  data: () => ({
    isLoading: false,
    isLoadingSearch: false,
    imgPath: imgPath,
    url: domain,
    menu: false,
    drawer: false,
    // access_token: false,
    isActive: "",
    lists: [
      {
        id: 1,
        name_list_th: "โปรไฟล์",
        name_list_en: "Profile",
        icon: "account_circle",
      },
      {
        id: 2,
        name_list_th: "ออกจากระบบ",
        name_list_en: "Logout",
        icon: "login",
      },
    ],
    keyword: "",
  }),
  created() {},
  computed: {
    ...mapState({
      personalInfo: (state) => state.profile.personalInfo,
      activeMainMenu: (state) => {
        return state.portfolio.activeMainMenu;
      },
      user: (state) => {
        return state.auth.users;
      },
      access_token: (state) => {
        return state.auth.access_token;
      },
      image_profile_facebook: (state) => {
        return state.auth.image_profile_facebook;
      },
      switchLanguage: (state) => {
        return state.Common.switchLanguage;
      },
      profile: (state) => {
        return state.profile.personalInfo;
      },
    }),
    currentRouteName() {
      return this.$route.name;
    },
  },
  methods: {
    onActive(val) {
      this.isActive = val;
      switch (val) {
        case 1:
          this.$store.dispatch("portfolio/clearActiveMenuCate", val);
          this.$router.push("/homepage");
          break;
        case 2:
          // this.isLoading = true;
          this.$store.dispatch("portfolio/clearActiveMenuCate", val);
          this.$store.dispatch("Collection/clearActiveMenuCreator", {
            id: 0,
            page: 1,
            custom_paginate: 0,
          });
          this.$router.push("/creator");
          break;
        case 3:
          this.$store.dispatch("portfolio/clearActiveMenuCate", val);
          this.$router.push("/toprank");
          break;
      }
    },
    routePusher() {
      if (this.$route.path !== "/create-portfolio") {
        if (this.access_token) {
          this.$router.push("/create-portfolio");
        } else {
          this.$swal({
            icon: "warning",
            title: this.$t("login-before-create"),
            confirmButtonColor: "#FD5246",
            confirmButtonText: "ตกลง",
          });
          // alert(this.$t('login-before-create'));
        }
      }
    },
    goLogin() {
      if (this.$route.path !== "/login") {
        this.$store.dispatch("portfolio/clearActiveMenuCate", 4);
        this.$router.push("/login");
      } else {
        this.drawer = false;
      }
    },
    onClickMenuList(id) {
      if (id === 1) {
        this.$store.dispatch("profile/onGetProfileInfo", this.user.profile_id);
        this.$store.dispatch("portfolio/clearActiveMenuCate", 0);
        this.$router.push("/profile-about");
      }
      if (id === 2) {
        this.$swal({
          text: "คุณต้องการออกจากระบบ ?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#FD5246",
          cancelButtonColor: "#525252",
          confirmButtonText: "ใช่",
          cancelButtonText: "ยกเลิก",
        }).then(async (result) => {
          if (result.value) {
            window.localStorage.removeItem("vuex");
            window.location = "/login";
          }
        });
      }
    },
    search() {
      this.isLoadingSearch = true;
      let data = { page: 1, keyword: this.keyword };
      this.$store
        .dispatch("portfolio/getPortfolioBySearch", data)
        .then((res) => {
          this.isLoadingSearch = false;
          this.$router.push({
            path: "/search",
            query: { keyword: this.keyword },
          });
        });
    },
    checkExpiresToken(profile_id) {
      this.$store.dispatch("auth/checkExpiresToken", profile_id);
    },
    checkImage(val, type) {
      if (val) {
        switch (type) {
          case "avatar":
            if (val.avatar) {
              return this.url + this.imgPath + "images_profile/" + val.avatar;
            } else {
              if (this.image_profile_facebook) {
                return this.image_profile_facebook;
              } else {
                return require("../assets/user_profile.png");
              }
            }
            // return val.avatar ? this.url+this.imgPath+'images_profile/'+val.avatar : require('../assets/user_profile.png');
            break;
          case "cover_url":
            return val.cover_url
              ? this.url +
                  this.imgPath +
                  "images_profile_cover/" +
                  val.cover_url
              : require("../assets/cover.png");
            break;
        }
      } else {
        return require("../assets/user_profile.png");
      }
    },
  },
};
</script>

<style>
.header-height {
  max-height: 75px !important;
  min-height: 74px !important;
}

.toolbar-active {
  color: #fd5246 !important;
}

.toolbar-active:hover {
  color: #fd5246;
}

.profile-list:hover {
  color: #fd5246;
  cursor: pointer;
}

.v-list.v-sheet.v-sheet--tile.theme--light {
  padding-bottom: 0;
  padding-top: 0;
}
.one-edge-shadow {
  -webkit-box-shadow: 0 -3px 5px 5px #c4c4c4;
  -moz-box-shadow: 0 -3px 5px 5px #c4c4c4;
  box-shadow: 0 -3px 5px 5px #c4c4c4;
}
@media only screen and (max-width: 768px) {
  .v-overlay__scrim {
    background-color: transparent !important;
  }
  i.v-icon.notranslate.mdi.mdi-menu.theme--light {
    height: 50px;
    font-size: 50px;
    width: 50px;
    padding-left: 1rem;
  }
}
</style>
